import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { TableHeaderTypesEnum } from '../reports.enum';

export const TABLE_HEADER_SCHEMA = Object.freeze({
  LABEL: '',
  TYPE: '',
});
const RECORD = generateSchema(TABLE_HEADER_SCHEMA);
const KEYS: any = generateKeys(TABLE_HEADER_SCHEMA);

export class TableHeader extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get type(): TableHeaderTypesEnum {
    return this.get(KEYS.TYPE);
  }

  get isNumberType(): boolean {
    const headerType = this.type;

    return (
      headerType === TableHeaderTypesEnum.currency ||
      headerType === TableHeaderTypesEnum.float ||
      headerType === TableHeaderTypesEnum.integer
    );
  }

  get isStringType(): boolean {
    const headerType = this.type;

    return headerType === TableHeaderTypesEnum.string;
  }
}
